import { BlockProps } from "../../containers/Block";

export default function Content({ block }: BlockProps) {
  if (block) {
    const blockData = JSON.parse(block.data || "");
    return <div>{blockData.content}</div>;
  } else return <></>;
}
